import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../mockData';

const WhatsAppButton = () => {
  return (
    <a
      href={contactInfo.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce"
      aria-label="Fale conosco no WhatsApp"
      title="Fale conosco no WhatsApp"
    >
      <MessageCircle size={32} strokeWidth={2.5} />
    </a>
  );
};

export default WhatsAppButton;
